<p-card>
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Clientes</h1>
      <p class="mb-3 text-color-secondary">
        Consulta la información de nuestros clientes actuales, incluyendo datos como RFC, tipo de persona, sector, ventas, empleados, teléfono y estatus, utiliza los filtros para acceder rápidamente a los datos necesarios.
      </p>
    </div>
    <p-toast></p-toast>
  </div>
  <div class="row">
    <div class="col-12">
      <p-tabView>
        <p-tabPanel header="Clientes" leftIcon="fa-solid fa-user-check">
          <app-main-table
            [apiService]="apiCustomerService"
            [columns]="clientesColumns"
            [additionalFilters]="clientesFilters"
            [pluralEntityName]="'clientes'"
            [additionalMainActions]="additionalMainActions"
            [actions]="actions"
            (onMainAction)="mainActions($event)"
            (onAction)="handleTableAction($event)"
          ></app-main-table>
        </p-tabPanel>
        <p-tabPanel header="Prospectos" leftIcon="fa-solid fa-user-clock">
          <app-main-table
            [apiService]="apiCustomerService"
            [columns]="prospectosColumns"
            [additionalFilters]="prospectosFilters"
            [pluralEntityName]="'prospectos'"
            [additionalMainActions]="additionalMainActions"
            [actions]="actions"
            (onMainAction)="mainActions($event)"
            (onAction)="handleTableAction($event)"
          ></app-main-table>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</p-card>
<!--Form to create or update a active-->
<p-dialog [(visible)]="createEntity" [style]="{ width: ' 1200px' }" [header]="action === 'CREATE' ? 'Nuevo cliente' : 'Editar cliente'" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-customer-new></app-customer-new>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text" (click)="saveForm()" [disabled]="!customerService.entity.valid"></button>
  </ng-template>
</p-dialog>
<!--End of form to create or update a active-->
